import { type Size } from '@contexts/dimensions'
import { type RefObject, useEffect, useState } from 'react'

export const useRefDimensions = (ref: RefObject<HTMLElement>) => {
  const [dimensions, setDimensions] = useState<Size | undefined>()

  useEffect(() => {
    const handleResize = () => {
      if (ref.current) {
        const { width, height } = ref.current.getBoundingClientRect()
        setDimensions({ width: Math.round(width), height: Math.round(height) })
      }
    }

    const isWindowDefined = typeof window !== `undefined`

    if (isWindowDefined) window.addEventListener('resize', handleResize)
    handleResize()
    return () => {
      if (isWindowDefined) window.removeEventListener('resize', handleResize)
    }
  }, [])
  return dimensions
}
